import { render, staticRenderFns } from "./EmbedLayout.vue?vue&type=template&id=093b88c8&scoped=true&"
import script from "./EmbedLayout.vue?vue&type=script&lang=js&"
export * from "./EmbedLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmbedLayout.vue?vue&type=style&index=0&id=093b88c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b88c8",
  null
  
)

component.options.__file = "EmbedLayout.vue"
export default component.exports